export default {
  defaultGraphYear: '',
  defaultGraphSeason: '',
  graphCheckbox: []
}
